import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Component } from 'react';
import PropTypes from 'prop-types';
import ShopInterface from '../../api/ShopInterface';
import { ShopTabs } from './Constants';
import Screens from '../index';
import QueryParamsProxy from '../../utils/queryParamProxy';
import RouteParamConstants, { ShopTypes as paramShopTypes } from '../../utils/routeParamConstants';
import buyClickedHandler from './buyClickedHandler';
import Logger from '../../lib/analytics/logger';
import { EVENT_TYPES } from '../../lib/analytics/constants';
import Utils from '../../utils';
import audio from '../../utils/audio';
import ENVIRONMENT_VARIABLES from '../../utils/environmentVariables';
import NotificationContext from '../../context/NotificationContext';
import { getText, TEXT_KEY } from '../../utils/localization';

var formatter = require('format-number');

var format = formatter({
  prefix: '',
  suffix: '',
  truncate: 0
});

var Shop = /*#__PURE__*/function (_Component) {
  _inherits(Shop, _Component);

  var _super = _createSuper(Shop);

  function Shop(props) {
    var _this;

    _classCallCheck(this, Shop);

    _this = _super.call(this, props);
    _this._buyServerHandler = buyClickedHandler;
    _this.checkBillingProfile = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var profiles;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return ShopInterface.getBillingProfiles();

            case 2:
              profiles = _context.sent;

              if (profiles.billingProfiles !== undefined) {
                _this.props.setPurchaseProfile(profiles.billingProfiles);
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    _this._getPackages = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var paramShopType, shopTab, _this$props, promoLink, setShopListCoins, isOutOfCoinsPurchase, isLTOPurchase, setShopListVip, currencyPackages, coinItems, vipItems, promoApplied, promoBoostDialogType, usedPromoBefore, i, saleEndDate, showPromoBoost, transformUnits, getFullUnitName, _i, _transformUnits, value, unitShort, unit;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;

              /**
               * @type {import("../../api/Constants").CurrencyPackagesResponse}
               */

              /** This bit automatically tabs over if the param is present. */
              paramShopType = QueryParamsProxy.findParam(RouteParamConstants.PARAM_SHOP_TYPE, paramShopTypes.COINS);
              _context2.t0 = paramShopType;
              _context2.next = _context2.t0 === paramShopTypes.COINS ? 5 : _context2.t0 === paramShopTypes.VIP ? 7 : 9;
              break;

            case 5:
              shopTab = ShopTabs.COINS;
              return _context2.abrupt("break", 10);

            case 7:
              shopTab = ShopTabs.VIP;
              return _context2.abrupt("break", 10);

            case 9:
              console.error('Invalid ShopType.');

            case 10:
              _this$props = _this.props, promoLink = _this$props.promoLink, setShopListCoins = _this$props.setShopListCoins, isOutOfCoinsPurchase = _this$props.isOutOfCoinsPurchase, isLTOPurchase = _this$props.isLTOPurchase, setShopListVip = _this$props.setShopListVip;

              if (!promoLink.code) {
                _context2.next = 17;
                break;
              }

              _context2.next = 14;
              return ShopInterface.getCurrencyPackages(promoLink.code);

            case 14:
              currencyPackages = _context2.sent;
              _context2.next = 20;
              break;

            case 17:
              _context2.next = 19;
              return ShopInterface.getCurrencyPackages();

            case 19:
              currencyPackages = _context2.sent;

            case 20:
              currencyPackages.PAYMENT_PROVIDER !== _this.props.paymentProvider && _this.props.setPaymentProvider(currencyPackages.PAYMENT_PROVIDER);
              coinItems = currencyPackages.PACKAGE_LIST.coins.items;
              vipItems = currencyPackages.PACKAGE_LIST.vip_room_access.items;
              promoApplied = currencyPackages.PACKAGE_LIST.coins.promo_applied;
              _this.promoApplied = promoApplied === 'yes' ? true : false;
              promoBoostDialogType = null;
              usedPromoBefore = false;
              if (promoLink.code) _this.props.lastPromoCode === promoLink.code ? usedPromoBefore = true : _this.props.setLastPromoCode(promoLink.code);

              if (promoApplied === 'yes' && !promoLink.active) {
                !usedPromoBefore ? promoBoostDialogType = 'success' : promoBoostDialogType = 'error';
              } else if (promoApplied === 'no') {
                promoBoostDialogType = 'error';
              }

              for (i = 0; i < coinItems.length; i++) {
                coinItems[i].AMOUNT = format(coinItems[i].AMOUNT);
                coinItems[i].ALT_AMOUNT = format(coinItems[i].ALT_AMOUNT);
                coinItems[i].ORIGINAL_AMOUNT = format(coinItems[i].ORIGINAL_AMOUNT);
                coinItems[i].BONUS_LOYALTY_AMOUNT = format(coinItems[i].BONUS_LOYALTY_AMOUNT);
                coinItems[i].PROMO_BOOSTED_VALUE = format(coinItems[i].PROMO_BOOSTED_VALUE);
                coinItems[i].AMOUNT_INCLUDING_SALE_AND_PROMO = format(coinItems[i].AMOUNT_INCLUDING_SALE_AND_PROMO);
                coinItems[i].PROMO_BOOST_PERCENTAGE = format(currencyPackages.PACKAGE_LIST.coins.promo_percentage);
                coinItems[i].SALE_PERCENTAGE = format(currencyPackages.PACKAGE_LIST.coins.sale_percentage);
              }

              saleEndDate = new Date();
              saleEndDate.setSeconds(saleEndDate.getSeconds() + currencyPackages.PACKAGE_LIST.coins.time_left || 0);
              showPromoBoost = promoApplied === 'yes' && promoLink.active;
              setShopListCoins(coinItems);
              isOutOfCoinsPurchase(false); // Making out-of-coins purchase to false

              isLTOPurchase(false);

              transformUnits = function transformUnits(value, unitName) {
                var units = [{
                  name: 'Sec',
                  divisorToNext: 60
                }, {
                  name: 'Min',
                  divisorToNext: 60
                }, {
                  name: 'Hr',
                  divisorToNext: 24
                }, {
                  name: 'Day'
                }];
                var unitIndex = units.findIndex(function (unit) {
                  return unit.name === unitName;
                }); // if we've already hit the max, return

                if (units[unitIndex].divisorToNext === undefined) {
                  return {
                    value: value,
                    unit: unitName
                  };
                }

                var newValue = value / units[unitIndex].divisorToNext; // if the new value goes below 1, we've divided too far, return

                if (newValue < 1) {
                  return {
                    value: value,
                    unit: unitName
                  };
                }

                return transformUnits(newValue, units[unitIndex + 1].name);
              };

              getFullUnitName = function getFullUnitName(shortUnitName) {
                switch (shortUnitName) {
                  case 'Sec':
                    return 'Second';

                  case 'Min':
                    return 'Minute';

                  case 'Hr':
                    return 'Hour';

                  default:
                    return shortUnitName;
                }
              };

              for (_i = 0; _i < vipItems.length; _i++) {
                _transformUnits = transformUnits(vipItems[_i].duration_in_seconds, 'Sec'), value = _transformUnits.value, unitShort = _transformUnits.unit;
                unit = getFullUnitName(unitShort);
                vipItems[_i].duration_friendly = "".concat(value, " ").concat(unitShort).concat(value !== 1 ? 's' : '');
                vipItems[_i].duration_friendly_full = "".concat(value, " ").concat(unit).concat(value !== 1 ? 's' : '');
              }

              _this.setState({
                vipItems: vipItems,
                shopTab: shopTab,
                coinItems: currencyPackages.PACKAGE_LIST.coins.items,
                saleEndDate: saleEndDate,
                isSaleOn: currencyPackages.PACKAGE_LIST.coins.sale,
                coinBackground: currencyPackages.PACKAGE_LIST.coins.sale_background_image,
                promoBoostDialogMessage: currencyPackages.PACKAGE_LIST.coins.message,
                promoBoostPercentage: currencyPackages.PACKAGE_LIST.coins.promo_percentage,
                promoBoostDialogType: promoBoostDialogType,
                showPromoBoost: showPromoBoost
              }, function () {
                return _this.checkToRedeemPromoLink();
              });

              setShopListVip(vipItems);
              _context2.next = 46;
              break;

            case 43:
              _context2.prev = 43;
              _context2.t1 = _context2["catch"](0);
              console.log(_context2.t1);

            case 46:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 43]]);
    }));

    _this._setShopTabHandler = function (newTab) {
      audio.onClick();
      var dismissModal = _this.props.dismissModal;

      switch (newTab) {
        case ShopTabs.BACK:
          {
            dismissModal();
            break;
          }

        case ShopTabs.COINS:
          {
            QueryParamsProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_SHOP_TYPE, paramShopTypes.COINS));
            break;
          }

        case ShopTabs.VIP:
          {
            QueryParamsProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_SHOP_TYPE, paramShopTypes.VIP));
            break;
          }

        default:
          console.error('Invalid tab');
      }

      _this.setState({
        shopTab: newTab
      });
    };

    _this._buyClickedHandler = function (sku, name, type, amount, trigger) {
      audio.onClick();
      Logger.setActionTrigger(trigger);
      var _this$props2 = _this.props,
          assignTransationUUID = _this$props2.assignTransationUUID,
          coins = _this$props2.coins;

      _this._buyServerHandler(sku, name);

      var platform = Utils.getPlatform();
      var store;

      switch (platform) {
        case 'web':
          store = 'cams';
          break;

        case 'ios':
          store = 'appstore';
          break;

        default:
          store = platform;
      }

      var id = Logger.generateUUID();
      assignTransationUUID(id);
      var eventPayload = {
        type: type === 'vip_room_access' ? 'vip' : 'regular',
        product_id: sku,
        currency: 'usd',
        store: store,
        balance_before: coins,
        is_test: ENVIRONMENT_VARIABLES.ENVIRONMENT !== 'PROD' ? 1 : 0,
        amount: amount,
        id: id,
        trigger: trigger
      };
      Logger.sendEvent(EVENT_TYPES.TRANSACTION_INITIATED, eventPayload);
    };

    _this._freeConsumableClickedHandler = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(itemId, itemType) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                audio.onClick();

                _this._freeConsumableServerHandler(itemId, itemType);

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x, _x2) {
        return _ref3.apply(this, arguments);
      };
    }();

    _this._freeConsumableServerHandler = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(itemId, itemType) {
        var setPurchaseType, success;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                setPurchaseType = _this.props.setPurchaseType;
                _context4.next = 4;
                return ShopInterface.claimFreeConsumable(itemId, itemType);

              case 4:
                success = _context4.sent;

                if (success) {
                  setPurchaseType(itemType);
                  QueryParamsProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.PurchaseSucceeded));
                } else {
                  _this.context.addNotification({
                    message: getText(TEXT_KEY.CONSUMABLE_CLAIM_FAILED_ALERT),
                    title: getText(TEXT_KEY.GENERIC_MESSAGE_ERROR),
                    button: getText(TEXT_KEY.OK)
                  });
                }

                ShopInterface.refreshActiveConsumables();
                _context4.next = 12;
                break;

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4["catch"](0);
                console.error(_context4.t0);

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[0, 9]]);
      }));

      return function (_x3, _x4) {
        return _ref4.apply(this, arguments);
      };
    }();

    _this._promoBoostDialogButtonHandler = function () {
      audio.onClick();

      _this.setState({
        promoBoostDialogType: null
      });
    };

    _this.checkToRedeemPromoLink = function () {
      var promoLink = _this.props.promoLink;

      if (promoLink && promoLink.code) {
        Logger.sendEvent(EVENT_TYPES.PROMOLINK_CLICKED, {
          code: promoLink.code
        });
      }

      var _this$state = _this.state,
          promoBoostDialogType = _this$state.promoBoostDialogType,
          promoBoostDialogMessage = _this$state.promoBoostDialogMessage,
          coinItems = _this$state.coinItems;
      var _this$props3 = _this.props,
          activatePromocode = _this$props3.activatePromocode,
          setShopListCoins = _this$props3.setShopListCoins,
          dismissInvalidPromocode = _this$props3.dismissInvalidPromocode;

      if (promoBoostDialogType !== null && !!promoBoostDialogMessage) {
        if (promoBoostDialogType === 'success' || _this.promoApplied) {
          _this.setState({
            showPromoBoost: true
          }, function () {
            activatePromocode();
            setShopListCoins(coinItems);
          });
        } else {
          dismissInvalidPromocode();
        }
      }
    };

    _this._hasVIPPass = function () {
      var _this$props4 = _this.props,
          isVipRoomUnlocked = _this$props4.isVipRoomUnlocked,
          memberLevel = _this$props4.memberLevel;
      var memberLevels = ['Gold', 'Platinum', 'Diamond'];

      if (isVipRoomUnlocked || memberLevels.includes(memberLevel)) {
        _this.props.dismissModal();

        QueryParamsProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.VipAccessFlow));
      }
    };

    _this.state = {
      /** @type {import('../../api/Constants').CurrencyPackageItemKeys[]} */
      coinItems: [],
      vipItems: [],
      shopTab: undefined,
      // Externally loaded, if available. Null otherwise.
      coinBackground: null
    };
    _this.promoApplied = false;
    return _this;
  }

  _createClass(Shop, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var isOffer, offerDetail;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                this._getPackages();

                this.checkBillingProfile();
                ShopInterface.refreshActiveConsumables();
                this._buyServerHandler = buyClickedHandler.bind(this);
                isOffer = QueryParamsProxy.findParam(RouteParamConstants.PARAM_OFFER_ENABLE, null);

                if (isOffer) {
                  offerDetail = QueryParamsProxy.findParam(RouteParamConstants.PARAM_OFFER_DETAIL, null);

                  this._buyServerHandler(offerDetail.sku, offerDetail.name, offerDetail.type, offerDetail.amount);
                }

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _QueryParamsProxy$set5;

      QueryParamsProxy.setQueryParams((_QueryParamsProxy$set5 = {}, _defineProperty(_QueryParamsProxy$set5, RouteParamConstants.PARAM_SHOP_TYPE, undefined), _defineProperty(_QueryParamsProxy$set5, RouteParamConstants.PARAM_OFFER_ENABLE, undefined), _QueryParamsProxy$set5));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          render = _this$props5.render,
          activeConsumables = _this$props5.activeConsumables,
          assetsUrls = _this$props5.assetsUrls,
          isVipRoomUnlocked = _this$props5.isVipRoomUnlocked;
      var _this$state2 = this.state,
          shopTab = _this$state2.shopTab,
          newsItems = _this$state2.newsItems,
          coinItems = _this$state2.coinItems,
          vipItems = _this$state2.vipItems,
          isSaleOn = _this$state2.isSaleOn,
          showPromoBoost = _this$state2.showPromoBoost,
          promoBoostDialogType = _this$state2.promoBoostDialogType,
          promoBoostDialogMessage = _this$state2.promoBoostDialogMessage,
          promoBoostPercentage = _this$state2.promoBoostPercentage,
          coinBackground = _this$state2.coinBackground,
          saleEndDate = _this$state2.saleEndDate;
      return render( // Pass state and handlers to platform renderer
      {
        assetsUrls: assetsUrls,
        shopTab: shopTab,
        setShopTabHandler: this._setShopTabHandler,
        newsItems: newsItems,
        coinItems: coinItems,
        vipItems: vipItems,
        buyHandle: this._buyClickedHandler,
        freeHandle: this._freeConsumableClickedHandler,
        activeConsumables: activeConsumables,
        isVipRoomUnlocked: isVipRoomUnlocked,
        isSaleOn: isSaleOn,
        showPromoBoost: showPromoBoost,
        promoBoostDialogType: promoBoostDialogType,
        promoBoostDialogMessage: promoBoostDialogMessage,
        promoBoostPercentage: promoBoostPercentage,
        promoBoostDialogButtonHandle: this._promoBoostDialogButtonHandler,
        hasVIPPass: this._hasVIPPass,
        // External assets to load
        coinSale: {
          backgroundImage: coinBackground,
          endDate: saleEndDate
        }
      });
    }
  }]);

  return Shop;
}(Component);

Shop.contextType = NotificationContext;
export { Shop as default };
Shop.propTypes = {
  promoLink: PropTypes.object,
  setShopListCoins: PropTypes.func.isRequired,
  isOutOfCoinsPurchase: PropTypes.func.isRequired,
  isLTOPurchase: PropTypes.func.isRequired,
  setShopListVip: PropTypes.func.isRequired,
  dismissModal: PropTypes.func.isRequired,
  setPurchaseType: PropTypes.func.isRequired,
  activatePromocode: PropTypes.func.isRequired,
  dismissInvalidPromocode: PropTypes.func.isRequired,
  render: PropTypes.func.isRequired,
  activeConsumables: PropTypes.any.isRequired,
  assignTransationUUID: PropTypes.any.isRequired,
  coins: PropTypes.any.isRequired
};
Shop.defaultProps = {
  promoLink: {}
};